import forgotPassword from './forgotPassword'

export default {
  forgotPassword,
}
